import * as React from 'react';

import IconButton from '../IconButton/IconButton';
import CrossIcon from '@geobank/assets/src/icons/CrossIcon';
import './ModalBox.css';

import RootPortal from '../RootPortal/RootPortal';

interface ModalBoxProps {
  children: React.ReactNode;
  width?: string;
  height?: string;
  isNeedCrossButton?: boolean;
  onClickCrossButton?: () => void;
}

// interface ModalBoxState {}

export default class ModalBox extends React.Component<ModalBoxProps, {}> {
  public render() {
    const { isNeedCrossButton, onClickCrossButton, width, height } = this.props;
    return (
      <RootPortal>
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            display: 'flex',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            zIndex: 999,
            transition: '0.8s',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            className={'modalBox'}
            style={{
              width: width || 'auto',
              height: height || 'auto',
              backgroundColor: '#ffffff',
              borderRadius: 3,
              boxSizing: 'border-box',
            }}
          >
            {isNeedCrossButton && (
              <div style={{ float: 'right', padding: 7 }}>
                <IconButton onClick={onClickCrossButton}>
                  <CrossIcon css={'background-color: #3333cc'} fill={'#6AC3FA'} />
                </IconButton>
              </div>
            )}
            <div
              style={{ width: '100%', height: '100%', /* padding: 20, */ boxSizing: 'border-box' }}
            >
              {this.props.children}
            </div>
          </div>
        </div>
      </RootPortal>
    );
  }
}
